export default __webpack_public_path__ + "static/media/classify1.c56ffd27.png";